<template>
  <div class="hello">
    <div class="bg">

      <div ref="footer" @scroll="scrollEvent($event)" :class="{isHei:detail_type == 2 ,footer:detail_type == 1}">
        <div class="center_bg">
          <div class="head">
            <div class="headerImage">
              <img :src="userInfo.avatar != '' ? userInfo.avatar : defaultImage" alt="">
            </div>
            <div class="userNam">
              <span>{{userInfo.truename != '' ? userInfo.truename : userInfo.phone}}</span>
            </div>

          </div>
          <div class="tabList" v-if="isFlag">
            <div class="tabs" :class="{isActive:item.isActive}" v-for="(item,index) in tabsList" :key="index" @click="tabEvent(index,item.id)">
              <span>{{item.name}}</span>
            </div>
          </div>
          <div class="tabLis" v-else>
            <div class="tabs isActive">
              <span>{{this.$t('language.my')}}</span>
            </div>
          </div>
          <div class="bianji" @click="banjiEvent">
            <img src="../assets/image/bianji.png" alt="">
          </div>
        </div>
        <div class="content">
          <div style="width: 319px;height: 308px;margin: 0 auto;" v-if="mylist.length <= 0 && isflag != 3">
            <img v-if="lang == 'cn'" src="../assets/image/wu.png" alt="">
            <img v-if="lang == 'en'" src="../assets/image/wuE.png" alt="">
          </div>
          <div class="myList" v-if="isflag == 1 && mylist.length > 0" v-for="(item,index) in mylist" :key="index"
            @click="detailEvent(item.id)">
            <div class="left">
             <!-- <p class="title">
                {{item.display_name}}
              </p> -->
              <p class="namea" style="font-size: 14px">
                {{$t('language.photoUser')}}：{{item.name}}
                <br>
                <span v-if="item.institution_name != ''">
                  {{$t('language.mechanism')}}:{{item.institution_name}}
                </span>
                <span v-if="item.school_name != ''">
                  {{$t('language.school')}}:{{item.school_name}}
                </span>
                <!-- <span style="font-size: 14px;" v-if="item.audit_status == 2">驳回原因: {{item.audit_fail_opinion}}</span> -->
              </p>
            </div>
            <div class="right">
              <div class="icon" :class="{successIcon:item.status == 1,errorIcon:item.status == 0,handIcon:item.status == 2}"></div>
              <div class="status" :class="{success:item.status == 1,error:item.status == 0,hand:item.status == 2}">
                <span>{{item.statusName}}</span>
              </div>
              <div class="icon successIcon" v-if="item.audit_status == 1"></div>
              <div class="icon zancunIcon" v-if="item.audit_status == -1"></div>
              <div class="status zancun" v-if="item.audit_status == -1">
                <span v-if="lang == 'cn'">{{item.auditStatusText}}</span>
                <span v-else>{{item.auditStatusTextEn}}</span>
              </div>
              <div class="status success" v-if="item.audit_status == 1">
                <span v-if="lang == 'cn'">{{item.auditStatusText}}</span>
                <span v-else>{{item.auditStatusTextEn}}</span>
              </div>
              <div class="icon handIcon" v-if="item.audit_status == 0"></div>
              <div class="status hand" v-if="item.audit_status == 0">
                <span v-if="lang == 'cn'">{{item.auditStatusText}}</span>
                <span v-else>{{item.auditStatusTextEn}}</span>
              </div>

              <div class="icon errorIcon" v-if="item.audit_status == 2"></div>
              <div class="status error" v-if="item.audit_status == 2">
                <span v-if="lang == 'cn'">{{item.auditStatusText}}</span>
                <span v-else>{{item.auditStatusTextEn}}</span>
              </div>
            </div>
          </div>
          <div class="myList" v-for="(item,index) in mylist" :key="index" v-if="isflag == 2" @click="voteDetail(item.id)">

            <div class="left">
              <p class="title">
                {{item.vote_act_title}}
              </p>
              <p class="namea">
                {{$t('language.photoUser')}}：{{item.photographer_name}}
              </p>

            </div>
            <div class="right">
              <div class="icon" :class="{successIcon:item.status == 1,errorIcon:item.status == 0,handIcon:item.status == 2}"></div>
              <div class="status" :class="{success:item.status == 1,error:item.status == 0,hand:item.status == 2}">
                <span>{{item.statusName}}</span>
              </div>
              <div class="icon successIcon" v-if="item.audit_status == 1"></div>
              <div class="status success" v-if="item.audit_status == 1">
                <span>通过</span>
              </div>
              <div class="icon handIcon" v-if="item.audit_status == 0"></div>
              <div class="status hand" v-if="item.audit_status == 0">
                <span>审核中</span>
              </div>

              <div class="icon errorIcon" v-if="item.audit_status == 2"></div>
              <div class="status error" v-if="item.audit_status == 2">
                <span>未通过</span>
              </div>
              <div class="clear"></div>
              <div class="number" v-if="item.audit_status == 1">
                票数:{{item.number}}
              </div>
            </div>

          </div>

          <!-- 个人中心商城 -->
          <div class="foote" v-if="isflag == 3">
            <div class="shopLeft">
              <div class="shop_title">
                <span>交易管理</span>
              </div>
              <div class="xuanLis">
                <div class="xuanList" :class="{xuanList_active:item.isActive}" v-for="(item,ind) in xuanList"
                  @click="xuanEvent(ind,item.id)">
                  <span>{{item.name}}</span>
                </div>
                <div class="shop_title">
                  <span>我的账户</span>
                </div>
                <div class="xuanList" :class="{xuanList_active:item.isActive}" v-for="(item,index) in zhanhuList"
                  @click="zhanhuEvent(index,item.id)">
                  <span>{{item.name}}</span>
                </div>
              </div>
            </div>
            <div class="shopRight" v-if="order_id == 0">
              <div class="top_shop">
                <div class="tab_list" :class="{tab_list_active:item.isActive}" v-for="(item,ind) in tabOver"
                  @click="tabEve(ind,item.order_type)">
                  <span>{{item.name}}</span>
                </div>
                <div class="clear"></div>
                <div class="goods_List">
                  <div class="table">
                    <div class="goods_name"></div>
                    <div class="goods_name">
                      商品
                    </div>
                    <div class="goods_number">
                      数量
                    </div>
                    <div class="goods_number">
                      价格
                    </div>
                    <div class="goods_number">
                      状态
                    </div>
                    <!-- <div class="goods_number">
                      操作
                    </div> -->
                  </div>
                  <div class="goodsList" v-if="goods_list.length <= 0">
                    <img src="../assets/image/noOrder.png" alt="">
                  </div>
                  <div class="goodsList" v-else v-for="(item,index) in goods_list"  @click="operationEvent(item.order_id)">
                    <div class="goods_top">
                      <p class="dingdan">订单号：{{item.ordersn}}</p>
                      <p class="success_time">下单时间：{{item.create_time}}</p>
					  <p  class="dingdan" style="float: right;margin-right: 80px;">{{item.orderTypeText}}</p>
                    </div>
                    <!-- <div class="down">
                      <span style="margin-left: 27px;">订单将在<span style="color: #AF0119;"> {{item.h}} </span>时<span style="color: #AF0119;">
                          {{item.m}} </span>分<span style="color: #AF0119;"> {{item.s}} </span>秒 后取消，请尽快完成付款</span>
                    </div> -->
                    <div class="goods_shop" v-for="(it,ind) in item.order_goods" :key="ind">
                      <div class="goods_name">
                        <div class="goods_pic">
                          <img :src="it.spec_pic" alt="">
                        </div>
                        <div class="goods_title">
                          <div class="spec_title" v-if="it.goods_title.length > 8">
                            <span>{{it.goods_title.substr(0,8)}}...</span>
                          </div>
                          <div class="spec_title" v-else>
                            <span>{{it.goods_title}}</span>
                          </div>
                          <div class="spec_desc">
                            <span>套餐：{{it.spec_name}}</span>
                          </div>
                          <!-- <div class="spec_desc" style="color:rgba(175,1,26,1);" v-if="it.status == 10">
                            <span>{{it.statusText}}</span>
                          </div> -->
                        </div>

                      </div>
                      <div class="goods_name"></div>
                      <div class="goods_number">
                        <div class="goods_num">
                          <span>{{it.goods_num}}个</span>
                        </div>
                      </div>
                      <div class="goods_number">
                        <div class="goods_prices">
                          <span>{{it.spec_price}}</span>
                        </div>
                      </div>
                      <div class="goods_number">
                        <div class="goods_status">
                          <span>{{it.statusText}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="submitBs">
                      <div class="caozuo">
                        <div class="operation_title" @click.stop="operationEvent(item.order_id)">
                          <span>查看订单</span>
                        </div>
                        <div class="operation_retitle" @click.stop="retitleEvent(item.order_id)" v-if="item.order_type == paid">
                          <span>取消订单</span>
                        </div>
                      </div>
                      <div class="goPay" v-if="item.order_type != 0">
                        <div class="pay_price" v-if="item.order_type == 1">
                          <span>应付：<span style="color: #AF0119;">¥{{item.all_price}}</span></span>
                        </div>
                        <div class="payBtn" @click.stop="aliPcRePay(index)" v-if="item.order_type == paid" >
                          <span>去支付</span>
                        </div>
                        <div class="auto" :class="{auto_active:item.isActive}" v-if="item.order_type == paid">
                          <!-- <div class="weixinpay" @click.stop="weiRepay(item.order_id)">
                            <div class="weixin">
                              <img src="../assets/image/weixin_pay.png" alt="">
                            </div>
                            <p>微信支付</p>
                          </div> -->
                          <div class="weixinpay">
                            <a @click.stop="" :href="url + item.order_id">
                              <div class="weixin">
                                <img src="../assets/image/zhifubao.png" alt="">
                              </div>
                              <p>支付宝</p>
                            </a>

                          </div>
                        </div>
                      <!--  <div class="payBtn" :class="{pay_active:item.is}" @click.stop="tixin(index)" v-if="item.order_type == delivered" >
                          <span>提醒发货</span>
                        </div> -->
                        <div class="payBtn color" v-if="item.order_type == received">
                          <span>查看物流</span>
                        </div>
                        <div class="payBtn" @click="payment()" v-if="item.order_type == received">
                          <span>确认收货</span>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>


            <div class="shopRight" v-if="order_id == 1">
              <div class="goods_List">
                <div class="table">
                  <div class="goods_name"></div>
                  <div class="goods_name">
                    商品
                  </div>
                  <div class="goods_number">
                    数量
                  </div>
                  <div class="goods_number">
                    价格
                  </div>
                  <div class="goods_number">
                    状态
                  </div>
                </div>
                <div class="goodsList" v-if="refundlist.length <= 0">
                  <img src="../assets/image/noOrder.png" alt="">
                </div>
                <div class="goodsList" v-else v-for="(item,index) in refundlist" :key="index" @click="refunddetail(item)">
                  <div class="goods_top">
                    <p class="dingdan">订单号：{{item.refund_ordersn}}</p>
                    <!-- <p class="success_time">成交时间：{{item.create_time}}</p> -->
                  </div>
                  <!-- <div class="down">
                  <span style="margin-left: 27px;">订单将在<span style="color: #AF0119;"> {{item.h}} </span>时<span style="color: #AF0119;">
                      {{item.m}} </span>分<span style="color: #AF0119;"> {{item.s}} </span>秒 后取消，请尽快完成付款</span>
                </div> -->
                  <div class="goods_shop" >
                      <div class="goods_name">
                        <div class="goods_pic">
                          <img :src="item.order_goods.spec_pic" alt="">
                        </div>
                        <div class="goods_title">
                          <div class="spec_title" v-if="item.order_goods.goods_title.length > 8">
                            <span>{{item.order_goods.goods_title.substr(0,8)}}...</span>
                          </div>
                          <div class="spec_title" v-else>
                            <span>{{item.order_goods.goods_title}}</span>
                          </div>
                          <div class="spec_desc">
                            <span>套餐：{{item.order_goods.spec_name}}</span>
                          </div>

                        </div>

                      </div>
                      <div class="goods_name"></div>
                      <div class="goods_number">
                        <div class="goods_num">
                          <span>{{item.order_goods.goods_num}}个</span>
                        </div>
                      </div>
                      <div class="goods_number">
                        <div class="goods_prices">
                          <span>{{item.order_goods.spec_price}}</span>
                        </div>
                      </div>
                      <div class="goods_number">
                        <div class="goods_status" style="color:rgba(175,1,26,1);">
                          <span>{{item.statusText}}</span>
                        </div>
                      </div>
                    </div>

                <!-- <div class="goods_shop" >
                    <div class="goods_name">
                      <div class="goods_pic">
                        <img :src="item.order_goods.spec_pic" alt="">
                      </div>
                      <div class="goods_title">
                        <div class="spec_title" v-if="it.goods_title.length > 8">
                          <span>{{it.goods_title.substr(0,8)}}...</span>
                        </div>
                        <div class="spec_title" v-else>
                          <span>{{it.goods_title}}</span>
                        </div>
                        <div class="spec_desc">
                          <span>套餐：{{it.spec_name}}</span>
                        </div>

                      </div>

                    </div>
                    <div class="goods_name"></div>
                    <div class="goods_number">
                      <div class="goods_num">
                        <span>{{it.goods_num}}个</span>
                      </div>
                    </div>
                    <div class="goods_number">
                      <div class="goods_prices">
                        <span>{{it.spec_price}}</span>
                      </div>
                    </div>
                    <div class="goods_number">
                      <div class="goods_status">
                        <span>{{item.orderTypeText}}</span>
                      </div>
                    </div>
                  </div>
 -->


                </div>
              </div>
            </div>


            <div class="shopRight" v-if="order_id == 4">
                 <div class="address_title">
                   <span>收货地址</span>
                 </div>
                 <div class="address_list">
                   <div class="add_list" :class="{border_active:item.is_default == 1}" v-for="(item,index) in addressList" :key="index">
                      <div class="address_top">
                          <div class="address_name">
                            {{item.name}}
                          </div>
                          <div class="address_name">
                            {{item.mobile.substr(0,3) + '*****' + item.mobile.substr(7)}}
                          </div>
                      </div>
                      <div class="content_address">
                        {{item.province}} {{item.city}} {{item.city}} {{item.area}}{{item.detail}}
                      </div>
                      <div class="bottom_address" >
                         <p style="color: #E83D3D;" @click="del(item.address_id)">删除</p>
                        <p style="margin-right: 8px;color: #1D5CBA;" @click="editEvent(item.address_id)">编辑</p>
                      </div>
                   </div>
                   <div class="add_address" @click="addressEve()">
                     <div class="uploadImage">
                       <div class="upload">
                         <img src="../assets/image/uploadAdd.png" alt="">
                       </div>
                       <div class="add_title">
                         <span>收货地址</span>
                       </div>
                     </div>
                   </div>
                 </div>
                 <div class="mask" v-if="addShow_address">
                   <div class="add_infor">
                     <div class="close" @click="closeEvent()">
                       <img src="../assets/image/close.png" alt="">
                     </div>
                     <div class="addInfo_top">
                       <span>{{address_title}}</span>
                     </div>
                     <div class="label">
                       <div class="addInfo_left">
                         <span style="color:#E83C3C;">*</span>收货人:
                       </div>
                       <input type="text" v-model="form.name" class="myinput">
                     </div>
                     <div class="label">
                       <div class="addInfo_left">
                         <span style="color:#E83C3C;">*</span>手机号:
                       </div>
                       <input type="text" v-model="form.mobile" class="myinput">
                     </div>
                     <div class="label">
                       <div class="addInfo_left">
                         <span style="color:#E83C3C;">*</span>收货地区:
                       </div>
                       <div class="input">
                         <v-distpicker :province="form.province" :city="form.city" :area="form.area" @province="onChangeProvince1" @city="onChangeCity"
                           @area="onChangeArea"></v-distpicker>
                       </div>
                     </div>
                     <div class="label">
                       <div class="addInfo_left">
                         <span style="color:#E83C3C;">*</span>详细地址:
                       </div>
                       <input type="text" v-model="form.detail" class="myinput">
                     </div>
                     <div class="default">
                       <div class="select" @click="defulteEvent()">
                         <img v-if="!selectDefult" src="../assets/image/selects.png" alt="">
                         <img v-else src="../assets/image/selects_active.png" alt="">
                       </div>
                       <div class="title">
                         <span>设置默认地址</span>
                       </div>
                     </div>

                     <div class="submitB" @click="submit()">
                       <span>保存</span>
                     </div>
                   </div>
                 </div>
            </div>







          </div>






          <div class="clear"></div>
          <div class="pages" v-if="isflag == 2">
            <el-pagination v-if="pageShow" background layout="prev, pager, next" :current-page="num" :total="total"
              @current-change="pageEvent">
            </el-pagination>
          </div>
          <!-- <div class="pages" v-if="isflag" >
           <el-pagination v-if="pageShow" background layout="prev, pager, next" :total="listTotal" @current-change="pageEvent">
           </el-pagination>
         </div> -->
          <div v-if="isflag != 3" style="height: 50px;"></div>
        </div>

      </div>
        <div class="weixin_mask" v-if="pay_shows">
              <div class="weixin_show">
                  <div class="close" @click="closeE()">
                    <img src="../assets/image/close.png" alt="">
                  </div>
                  <div class="show_top">
                      <span>微信支付</span>
                  </div>
                  <div class="weixin_erwei">
                    <div id="qrcode" ref="qrcode"></div>
                  </div>
                  <div class="weix_title">
                    <span>请使用微信扫一扫</span>
                  </div>
                  <div class="weixi_retitle">
                    <span>二维码完成支付</span>
                  </div>
              </div>
        </div>
        <fiex :shows="fixed" :fatherMethod="goTop" ref="fiex"></fiex>
    </div>
  </div>
</template>

<script>
   import QRCode from 'qrcodejs2'
   import fiex from '../components/fiex.vue'
   import VDistpicker from 'v-distpicker'
  export default {
    components: {
      QRCode,
      VDistpicker,
      fiex
    },
    data() {
      return {
        fixed: true,
        isShow: false,
        addressList:[],
        defaultImage: require('../assets/image/defaultHeader.png'),
        imageUrl: require('../assets/image/banner1.png'),
        mylist: [],
        isflag: 1,
        works: [],
        isFlag: false, //是否显示投票作品
        userInfo: {},
        lang: 'cn',
        pageShow: true,
        total: null,
        num: 1,
        goods_list: [],
        arr: [],
        day: 0,
        detail: {},
        detailShow: false,
        order_id: 0,
        detail_type: 1,
        page: 1, // 订单列表分页数
        refundPage:1, // 退款列表分页数
        payShows:false,
        Cancelled: 0,
        paid: 1,
        delivered: 2,
        received: 3,
        Completed: 5,
        pay_shows:false,
        error: false,
        addShow_address:false,
        selectDefult:false,
        form: {
          name: '',
          mobile: '',
          province: '',
          city: '',
          area: '',
          detail:'',
          tag:'',
          is_default:0
        },
        zhanhuList: [{
          name: '收货地址',
          isActive: false
        }],
        tabOver: [{
            name: '全部订单',
            isActive: true,
            order_type: ''
          },
          {
            name: '待付款',
            isActive: false,
            order_type: 1
          },
          {
            name: '待发货',
            isActive: false,
            order_type: 2
          },
          {
            name: '待收货',
            isActive: false,
            order_type: 3
          },
          {
            name: '已完成',
            isActive: false,
            order_type: 5
          }
        ],
        refundlist:[],
        refundShow:false,
		address_title:'新建收货地址',
		url:''
      }
    },
    computed: {
      xuanList(){
         var arr =  [{
          name: '我的订单',
          isActive: true,
          id: 0

        },
        {
          name: '退款/退货',
          isActive: false,
          id: 1
        }
      ];
      return arr;
      },
      tabsList() {
        var arr = [{
            name: this.$t('language.my'),
            isActive: true,
            id: 1
          },
          // {
          //   name: this.$t('language.work'),
          //   isActive: false,
          //   id: 2
          // },
          // {
          //   name:this.$t('language.shops'),
          //   isActive:false,
          //   id:3
          // }
        ]
        return arr;
      }
    },
    created() {
		let falg = true;
		this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
		console.log(this.userInfo);
		if(falg){
			this.url = "https://admin.pipyz.com.cn/index.php/api/order/aliPcPay?order_id=";
		}else{
			this.url = "http://shoot.pingyao888.cn/index.php/api/order/aliPcPay?order_id=";
		}
		
      if(this.$route.query.type == 'shop'){
        this.isflag = 3;
        this.tabsList.forEach(item=>{
          item.isActive = false;
        })
        this.tabsList[1].isActive = true;
        this.shopList();
      }
      this.xuanList.forEach((item,index)=>{
        item.isActive = false;
        if(item.id == this.$route.query.order_id){
           item.isActive = true;
           this.xuanEvent(index,item.id);
        }else{
          this.xuanList[0].isActive = true;
        }
      })
      if (localStorage.getItem('languageSet') == 'en') {
        this.lang = 'cn'
      } else {
        this.lang = 'en'
      }
      this.ajaxFun()
      if (localStorage.getItem('gerenindex') && localStorage.getItem('tabtype') == 2) {
        var gerenindex = localStorage.getItem('gerenindex');
        var pageIndex = parseInt(localStorage.getItem('pageIndex'));
        this.tabEvent(gerenindex, gerenindex == '1' ? 2 : 1)
        this.toupiao(pageIndex)
        this.num = pageIndex;
      }
      if (localStorage.getItem('tabtype') == 3) {
        var gerenindex = localStorage.getItem('gerenindex');
        this.tabEvent(gerenindex,3)
      }
    },
    mounted() {


    },
    methods: {
      tixin(index){
        this.goods_list.forEach(item=>{
          item.is = false;
        })
        this.goods_list[index].is = true;
        this.$message.success('提醒成功');
      },
      onChangeProvince1(e){
        if(e.code != 'undefined'){
           this.form.province = e.value;
        }
      },
      onChangeCity(e){
       if(e.code != 'undefined'){
            this.form.city = e.value;
       }
      },
      onChangeArea(e){
        if(e.code != 'undefined'){
             this.form.area = e.value;
        }
      },
     editEvent(id){
		 this.address_title = '编辑收货地址'
       this.$fetch('useraddress/detail',{id:id}).then(res=>{
             if(res.code == 200){
               this.form = res.data;
               this.form.id = res.data.address_id;
               if(res.data.is_default == 1){
                 this.selectDefult = true;
               }else{
                 this.selectDefult = false;
               }
               this.addShow_address = true;
             }
       })
     },
      del(id){
          this.$post('useraddress/del',{id:id}).then(res=>{
            if(res.code == 200){
              this.$message.success('删除成功');
              this.addressL();
            }
          })
      },
      defulteEvent() {
        this.selectDefult = !this.selectDefult;
      },
      addressEve(){
		  this.address_title = '新建收货地址'
		this.addShow_address = true;
      },
      closeEvent(){
        this.form = {}
        this.selectDefult = false;
        this.addShow_address = false;
      },
      refunddetail(item){
        this.$router.push({
          path:'/refunddetail',
          query:{
            id:item.order_refund_id
          }
        })
      },
      weiRepay(id){
        var that  = this;
        this.$fetch('order/wxPcRePay',{order_id:id}).then(res=>{
          if(res.code == 200){
            that.$nextTick(()=>{
             that.$nextTick(()=>{
                that.creatQrCode(res.data);
             })
            })
            that.pay_shows = true;
          }
        })
      },
      creatQrCode(url) {
        var qrcode = new QRCode('qrcode', {
          width: 266,
          height: 246,
          text: url, // 二维码地址
          colorDark: "#000",
          colorLight: "#fff",
          correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
        })
        console.log(qrcode);
      },
      open() {
        this.isShow = true;
      },
      retitleEvent(id) {
        this.$fetch('order/cancel', {
          id: id
        }).then(res => {
          if (res.code == 200) {
            this.$message.success('取消成功');
            this.shopList();
          }
        })
      },
      submit() {
        if(this.selectDefult){
          this.form.is_default = 1
        }else{
           this.form.is_default = 0;
        }
        this.$post('useraddress/add',this.form).then(res=>{
          if(res.code== 200){
             this.$message.success('添加成功');
             this.addShow_address = false;
             this.form = {};
             this.addressL();
          }
        })
      },
      shopList(id, page) {
        if (id != 'undefined') {
          localStorage.setItem('id', id);
        }
        this.$fetch('order/list', {
          order_type: id ? id : '',
          page: page ? page : 1
        }).then(res => {
          if(res.code == 200){
              this.goods_list = res.data.data;
              this.goods_list.forEach(item=>{
                this.$set(item,'isActive',false);
              })
          }
          if(res.code == 901){
            this.$message.error('暂不支持英文版本商城')
          }
          // this.goods_list.forEach(item => {
          //   var time_now_client, time_server_client;
          //   var time_now_server = new Date();
          //   time_now_server = time_now_server.getTime();
          //   var time_end = new Date(item.end_time);
          //   time_end = time_end.getTime(); // 结束时间
          //   time_now_client = new Date();
          //   time_now_client = time_now_client.getTime();
          //   time_server_client = time_now_server - time_now_client;
          //   function timeFunction(){
          //     var time_now, time_distance, str_time;
          //     var time_now = new Date();
          //     time_now = time_now.getTime() + time_server_client;

          //     time_distance = time_end - time_now;
          //     if (time_distance > 0) {
          //       item.day = Math.floor(time_distance / 86400000);
          //       time_distance -= item.day * 86400000;
          //       item.h = Math.floor(time_distance / 3600000)
          //       time_distance -= item.h * 3600000;
          //       item.m = Math.floor(time_distance / 60000)
          //       time_distance -= item.m * 60000;
          //       item.s = Math.floor(time_distance / 1000)
          //         if (item.h < 10)
          //           item.h = "0" + item.h;
          //         if (item.m < 10)
          //           item.m = "0" + item.m;
          //         if (item.s < 10)
          //           item.s = "0" + item.s;
          //     } else {
          //       item.h = '00';
          //       item.m = '00';
          //       item.s='00'
          //     }
          //   }
          //   timeFunction();
          // })

        })


      },
      goTop(){
        this.$refs.footer.scrollTop = 0;
      },
      operationEvent(id) {
        this.$refs.footer.scrollTop = 0;
        this.$router.push({
          path: '/goodsdetail',
          query: {
            id: id
          }
        })
        // this.$fetch('order/detail', {
        //   id: id
        // }).then(res => {
        //   this.detail = res.data;
        //   this.detailShow = true;
        //   this.detail_type = 2;
        // })
      },
      ajaxFun() {
      
        this.$post('/Apply/list').then(res => {
          this.mylist = res.data;

        })
      },
      toupiao(pages) {
        var data = {
          page: pages,
        }
        this.$fetch('/center/voteList', data).then(res => {
          this.mylist = res.data.data;
          this.total = res.data.total;
          if (this.mylist.length <= 0) {
            this.pageShow = false;
          } else {
            this.pageShow = true;
          }
        })
      },
      pageEvent(e) {
        localStorage.setItem('pageIndex', e);
        this.toupiao(e)
      },
      // 执行下拉加载
      scrollEvent(e) {
        if (this.isflag == 3) {
          let scrollBottom =
            event.target.scrollHeight -
            event.target.scrollTop -
            event.target.clientHeight;

          if(this.order_id == 1){

           if(scrollBottom <= 0){
             this.refundPage += 1;
             this.jiazairefund(this.refundPage);
           }
          }else{
            if (scrollBottom <= 0) {
              this.page += 1;
              this.jiazaiList(localStorage.getItem('id'), this.page);
            }
          }

        }
      },
      closeE(){
        this.pay_shows = false;
      },
      jiazairefund(page){
          if(!this.refundShow){
              this.$fetch('refund/list',{page,page}).then(res=>{
                 res.data.data.forEach(item=>{
                    this.refundlist.push(item);
                 })
                 console.log(res.data.data);
                 if(res.data.data.length <= 0){
                   this.refundShow = true;
                 }else{
                   this.refundShow = false;
                 }
              })
          }

      },
      // 请求分页数据
      jiazaiList(id, page) {
        if (id == 'undefined') {
          // 缓存中 id 是 undefined 证明是刚进页面
          id = localStorage.getItem('id') == 'undefined' ? '' : localStorage.getItem('id');
        }
        if (!this.error) {
          this.$fetch('order/list', {
            order_type: id ? id : '',
            page: page ? page : 1
          }).then(res => {
            console.log(res);
            res.data.data.forEach(item => {
              this.goods_list.push(item)
            })
            this.goods_list.forEach(item=>{
              this.$set(item,'isActive',false);
            })
            if (res.data.data.length <= 0) {
              this.error = true;

            } else {
              this.error = false;
            }
          })
        }

      },
      aliPcRePay(index){
        console.log(index)
        var that = this;
       for(var i = 0; i < this.goods_list.length;i++){
         this.goods_list[i].isActive = false;
       }
       this.goods_list[index].isActive = true;
       setTimeout(function(){
         that.goods_list[index].isActive = false;
       },5000)
      },
      tabEvent(index, id) {
        this.page = 1;
        localStorage.setItem('gerenindex', index)
        localStorage.setItem('tabtype', id);

        for (var i = 0; i < this.tabsList.length; i++) {
          this.tabsList[i].isActive = false;
        }
        this.tabsList[index].isActive = true;
        var that = this;
        if (id == 2) {
          this.num = 1;
          this.isflag = 2;
          this.toupiao(1)
        } else if (id == 1) {
          this.isflag = 1;
          this.$post('/Apply/list').then(res => {
            this.mylist = res.data;

          })
        } else if(id == 3){
          this.isflag = 3;
          this.shopList();
        }
      },
      voteDetail(id) {
        this.$router.push({
          path: '/examine',
          query: {
            item_id: id
          }
        })
      },
      banjiEvent() {
        this.$router.push('/account')
      },
      detailEvent(id) {
        this.$router.push({
          path: '/modify',
          query: {
            id: id
          }
        })
      },
      addressL(){
        this.$fetch('useraddress/list').then(res=>{
          this.addressList = res.data;
        })
      },
      zhanhuEvent(index, id) {
        this.xuanList.forEach(item => {
          item.isActive = false;
        })
        this.zhanhuList.forEach(item => {
          item.isActive = false;
        })
        this.zhanhuList[index].isActive = true;
        this.order_id = 4
         this.addressL();
      },
      xuanEvent(index, id) {
        this.detailShow = false;
        this.detail_type = 1;
        this.xuanList.forEach(item => {
          item.isActive = false;
        })
        this.zhanhuList.forEach(item => {
          item.isActive = false;
        })
        this.xuanList[index].isActive = true;
        this.order_id = id;
        if (id == 1) {
          this.$fetch('refund/list',{page:1}).then(res => {
            console.log(res);
            this.refundlist = res.data.data;
          })
        }
      },
      tabEve(index, id) {
        this.tabOver.forEach(item => {
          item.isActive = false;
        })
        this.tabOver[index].isActive = true;
        this.page = 1;
        this.error = false;
        this.shopList(id);
      }
    }
  }
</script>

<style scoped="scoped">
  @import url("../assets/css/personal.css");
</style>



// WEBPACK FOOTER //
// src/pages/personal.vue